/**
 * @generated SignedSource<<0fc163061eee52c22c029d3cf50ff5b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type moduleRatingDetailsTable_ModuleRatingInlineFragment$data = {
  readonly createdAt: string;
  readonly message: string;
  readonly node: {
    readonly id: string;
    readonly structureDefinition: {
      readonly title: string;
    };
  } | null | undefined;
  readonly oneKeyId: string | null | undefined;
  readonly user: {
    readonly id: string;
    readonly name: string;
  } | null | undefined;
  readonly value: number;
  readonly " $fragmentType": "moduleRatingDetailsTable_ModuleRatingInlineFragment";
};
export type moduleRatingDetailsTable_ModuleRatingInlineFragment$key = {
  readonly " $data"?: moduleRatingDetailsTable_ModuleRatingInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"moduleRatingDetailsTable_ModuleRatingInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "moduleRatingDetailsTable_ModuleRatingInlineFragment"
};

(node as any).hash = "08265f9ee4ddc8495f88705eae58c682";

export default node;
